import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'users',
        path: 'users',
        redirect: { name: 'user-list' },
        children: [
          {
            name: 'user-list',
            path: '',
            component: () => import('../pages/users/UsersPage.vue'),
          },
          {
            name: 'user-detail-experience',
            path: ':id/experience',
            component: () => import('../pages/users/UserExperience.vue'),
            // children: [
            //   {
            //     name: 'user-detail-info',
            //     path: '',
            //     component: () => import('../pages/users/UserDetail.vue'),
            //   },
            //   {
            //     name: 'user-detail-experience',
            //     path: 'experience',
            //     component: () => import('../pages/users/UserExperience.vue'),
            //   },
            // ]
          },
        ],
      },
      {
        name: 'subscriptions',
        path: 'subscriptions',
        component: () => import('../pages/subscriptions/SubscriptionPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    meta: { noAuth: true },
    children: [
      {
        name: 'login',
        path: 'login',
        meta: { title: 'Login', noAuth: true, authRedirect: true },
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
        meta: { title: 'Login', noAuth: true, authRedirect: true },
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
        meta: { title: 'Login', noAuth: true, authRedirect: true },
      },
      {
        name: 'reset-password',
        path: 'reset-password',
        component: () => import('../pages/auth/ResetPassword.vue'),
        meta: { title: 'Login', noAuth: true, authRedirect: true },
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

// configure router guards
router.beforeEach((to, _from, next) => {
  // check if the route requires authentication and user is not logged in
  // console.log(to.matched.some((record) => !record.meta.noAuth))
  if (to.matched.some((record) => !record.meta.noAuth) && !localStorage.getItem('accessToken')) {
    // redirect to login page
    next({ name: 'login' })
  } else {
    // check is authRedirect in and redirect to dashboard
    if (to.meta.authRedirect && localStorage.getItem('accessToken')) {
      next({ name: 'dashboard' })
    } else {
      next()
    }
  }
})

export default router
